"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("./styles/index.css");
var _react = _interopRequireWildcard(require("react"));
var _reactLeaflet = require("react-leaflet");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
const wheelchairSeat = require('.//assets/wheelchair.png');
const SeatingPlan = _ref => {
  let {
    eventId,
    showingUid,
    sessionId,
    showingId,
    priceAgeId,
    priceSectionId,
    price,
    quantity,
    callbackFunction,
    apiKey,
    baseUrl
  } = _ref;
  const [position, setPosition] = (0, _react.useState)(null);
  const [height, setHeight] = (0, _react.useState)(0);
  const [width, setWidth] = (0, _react.useState)(0);
  const [seats, setSeats] = (0, _react.useState)([]);
  const [error, setError] = (0, _react.useState)(null);
  const [processing, setProcessing] = (0, _react.useState)(false);
  const [bookedSeats, setBookedSeats] = (0, _react.useState)([]);
  const [chosenSeat, setChosenSeat] = (0, _react.useState)(null);
  const statusColors = {
    unknown: '#95a5a6',
    available: '#2ecc71',
    sold: '#95a5a6',
    reserved: '#95a5a6',
    pending: '#e74c3c',
    booked: '#e74c3c',
    bookedWithDifferentPrice: '#fab1a0'
  };
  const setInitialColor = s => {
    return {
      fillColor: s.status === 1 ? statusColors.available : s.status === 4 ? s.bookedPrice === price ? statusColors.booked : statusColors.bookedWithDifferentPrice : statusColors.sold,
      color: 'none',
      fillOpacity: 100
    };
  };
  const handleClick = (e, s) => {
    if (s.status !== 1 && s.status !== 4 || processing || bookedSeats.length >= quantity && s.status === 1) {
      if (bookedSeats.length >= quantity) {
        const event = {
          type: 'error',
          details: {
            message: 'Maximum ticket booking quantity specified reached.'
          }
        };
        callbackFunction(event);
      }
      return;
    }
    setChosenSeat({
      circle: e,
      seat: s
    });
    setProcessing(true);
    if (s.status === 1) {
      fetch("https://apim.iticket.co.nz/seatingplan/addseat", {
        method: 'POST',
        body: JSON.stringify({
          basketKey: '',
          eventId: eventId,
          showingId: showingId,
          priceAgeId: priceAgeId,
          seatId: s.showingSeatId,
          status: s.status,
          price: price
        }),
        headers: {
          'content-type': 'application/json',
          'session-id': "ASP.NET_SessionId=".concat(sessionId),
          'showingseat-id': s.showingSeatId
        }
      }).then(response => response.json()).then(response => {
        s.status = 4;
        s.bookedPrice = price;
        e.target.setStyle({
          fillColor: statusColors.booked
        });
        setProcessing(false);
        setBookedSeats([...bookedSeats, {
          showingSeatId: s.showingSeatId,
          rowName: s.rowName,
          columnName: s.columnName,
          showingId: showingId,
          price: price || s.defaultPrice,
          priceAgeName: s.priceAgeName
        }]);
      }).catch(error => {
        e.target.setStyle({
          fillColor: statusColors.available
        });
        const event = {
          type: 'error',
          details: s.priceMinimum && s.priceMaximum && (price < s.priceMinimum || price > s.priceMaximum) ? {
            error: {
              code: 403,
              message: 'Price specified not allowed.'
            }
          } : {
            error: {
              code: 500,
              message: 'Oops! Something went wrong. Please try again.'
            }
          }
        };
        callbackFunction(event);
        setProcessing(false);
      });
    } else {
      if (s.bookedPrice === price) {
        fetch("https://apim.iticket.co.nz/seatingplan/removeseat", {
          method: 'POST',
          body: JSON.stringify({
            basketKey: '',
            seatId: s.showingSeatId
          }),
          headers: {
            'content-type': 'application/json',
            'session-id': "ASP.NET_SessionId=".concat(sessionId),
            'showingseat-id': s.showingSeatId
          }
        }).then(response => response.json()).then(response => {
          s.status = 1;
          s.bookedPrice = null;
          e.target.setStyle({
            fillColor: statusColors.available
          });
          setBookedSeats(bookedSeats.filter(bs => bs.showingSeatId !== s.showingSeatId));
          setProcessing(false);
        }).catch(error => {
          e.target.setStyle({
            fillColor: statusColors.booked
          });
          const event = {
            type: 'error',
            details: {
              error: {
                code: 500,
                message: 'Oops! Something went wrong. Please try again.'
              }
            }
          };
          callbackFunction(event);
          setProcessing(false);
        });
      } else {
        const event = {
          type: 'error',
          details: {
            error: {
              code: 403,
              message: "Unable to remove seat. Price specified does not match the selected seat price, please select $".concat(s.bookedPrice, " to be able to remove this seat.")
            }
          }
        };
        callbackFunction(event);
        setProcessing(false);
      }
    }
  };
  // https://ecommerce-main-f0c3c0b.d2.zuplo.dev
  (0, _react.useEffect)(() => {
    if (!position && !error) {
      fetch("".concat(baseUrl, "/ecommerce/v1/events/").concat(eventId, "/showings/").concat(showingId, "/seats?priceage=").concat(priceAgeId), {
        headers: {
          basketId: sessionId,
          Authorization: "Bearer ".concat(apiKey)
        }
      }).then(response => response.json() || null).then(data => {
        const img = new Image();
        img.src = data.background;
        setBookedSeats(data.seats.filter(s => s.status === 4 && s.bookedPrice === price).map(s => ({
          showingSeatId: s.showingSeatId,
          rowName: s.rowName,
          columnName: s.columnName,
          showingId: showingId,
          price: price || s.defaultPrice,
          priceAgeName: s.priceAgeName
        })));
        img.onload = () => {
          setHeight(img.height);
          setWidth(img.width);
          setPosition([img.height * 0.03 / 2, img.width * 0.03 / 2]);
          setSeats(data);
        };
      }).catch(error => {
        setError({
          response: {
            data: {
              message: 'Invalid API Key or unauthorized URL'
            }
          }
        });
      });
    }
  }, [position]);
  (0, _react.useEffect)(() => {
    if (bookedSeats && position && chosenSeat) {
      const event = {
        type: 'cart-change',
        details: bookedSeats
      };
      callbackFunction(event);
    }
  }, [bookedSeats]);
  (0, _react.useEffect)(() => {
    if (processing) {
      chosenSeat === null || chosenSeat === void 0 ? void 0 : chosenSeat.circle.target.setStyle({
        fillOpacity: 0
      });
    }
  }, [chosenSeat]);

  // return seating plan
  return /*#__PURE__*/_react.default.createElement("div", {
    style: {
      width: '100%',
      height: '100%'
    }
  }, error ? /*#__PURE__*/_react.default.createElement("div", {
    className: "loading"
  }, /*#__PURE__*/_react.default.createElement("h1", null, "OOPS!"), /*#__PURE__*/_react.default.createElement("div", null, error.response.data.message)) : position ? /*#__PURE__*/_react.default.createElement(_reactLeaflet.MapContainer, {
    center: position,
    zoom: 5,
    scrollWheelZoom: true,
    style: {
      minHeight: '500px',
      height: '100%'
    }
    // onClick={handleClick}
  }, /*#__PURE__*/_react.default.createElement(_reactLeaflet.ImageOverlay, {
    url: seats.background,
    bounds: [[0, 0], [height * 0.03, width * 0.03]],
    zIndex: 10
  }), seats && seats.seats && seats.seats.map((s, i) => /*#__PURE__*/_react.default.createElement("div", {
    key: i
  }, /*#__PURE__*/_react.default.createElement(_reactLeaflet.ImageOverlay, {
    url: "https://iticketseatingplan.blob.core.windows.net/embed/static/media/rippleload.08e6a08dd832819226ef.gif",
    bounds: [[height * 0.03 - s.raw_y * 0.61 - 0.2, s.raw_x * 0.615 - 0.2], [height * 0.03 - s.raw_y * 0.61 + 0.2, s.raw_x * 0.615 + 0.2]],
    opacity: chosenSeat && chosenSeat.seat.showingSeatId === s.showingSeatId ? 100 : 0,
    zIndex: 10
  }), !priceSectionId || s.priceSectionId === priceSectionId ? s.status === 6 ? /*#__PURE__*/_react.default.createElement(_reactLeaflet.ImageOverlay, {
    url: 'data:image/svg+xml;base64,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',
    bounds: [[height * 0.03 - s.raw_y * 0.61 - 0.17, s.raw_x * 0.615 - 0.17], [height * 0.03 - s.raw_y * 0.61 + 0.17, s.raw_x * 0.615 + 0.17]],
    zIndex: 10
  }) : /*#__PURE__*/_react.default.createElement(_reactLeaflet.Circle, {
    center: [
    // (width * 0.03 - (s.raw_y - 11.5)) * 0.65,
    // s.raw_x * 0.64,
    height * 0.03 - s.raw_y * 0.61, s.raw_x * 0.615],
    pathOptions: setInitialColor(s),
    radius: 20000,
    eventHandlers: {
      click: e => handleClick(e, s)
    }
    // value={s}
  }, /*#__PURE__*/_react.default.createElement(_reactLeaflet.Tooltip, {
    direction: 'top',
    offset: [0, height * 0.03 + -30]
  }, s.rowName + '-' + s.columnName, ' ', s.bookedPrice && s.bookedPrice !== price && "(Select $".concat(s.bookedPrice, " to remove from cart.)"))) : /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null)))) : /*#__PURE__*/_react.default.createElement("div", {
    className: "loading"
  }, /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("svg", {
    width: "105",
    height: "105",
    viewBox: "0 0 105 105",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#2ecc71"
  }, /*#__PURE__*/_react.default.createElement("circle", {
    cx: "12.5",
    cy: "12.5",
    r: "12.5"
  }, /*#__PURE__*/_react.default.createElement("animate", {
    attributeName: "fill-opacity",
    begin: "0s",
    dur: "1s",
    values: "1;.2;1",
    calcMode: "linear",
    repeatCount: "indefinite"
  })), /*#__PURE__*/_react.default.createElement("circle", {
    cx: "12.5",
    cy: "52.5",
    r: "12.5",
    fillOpacity: ".5"
  }, /*#__PURE__*/_react.default.createElement("animate", {
    attributeName: "fill-opacity",
    begin: "100ms",
    dur: "1s",
    values: "1;.2;1",
    calcMode: "linear",
    repeatCount: "indefinite"
  })), /*#__PURE__*/_react.default.createElement("circle", {
    cx: "52.5",
    cy: "12.5",
    r: "12.5"
  }, /*#__PURE__*/_react.default.createElement("animate", {
    attributeName: "fill-opacity",
    begin: "300ms",
    dur: "1s",
    values: "1;.2;1",
    calcMode: "linear",
    repeatCount: "indefinite"
  })), /*#__PURE__*/_react.default.createElement("circle", {
    cx: "52.5",
    cy: "52.5",
    r: "12.5"
  }, /*#__PURE__*/_react.default.createElement("animate", {
    attributeName: "fill-opacity",
    begin: "600ms",
    dur: "1s",
    values: "1;.2;1",
    calcMode: "linear",
    repeatCount: "indefinite"
  })), /*#__PURE__*/_react.default.createElement("circle", {
    cx: "92.5",
    cy: "12.5",
    r: "12.5"
  }, /*#__PURE__*/_react.default.createElement("animate", {
    attributeName: "fill-opacity",
    begin: "800ms",
    dur: "1s",
    values: "1;.2;1",
    calcMode: "linear",
    repeatCount: "indefinite"
  })), /*#__PURE__*/_react.default.createElement("circle", {
    cx: "92.5",
    cy: "52.5",
    r: "12.5"
  }, /*#__PURE__*/_react.default.createElement("animate", {
    attributeName: "fill-opacity",
    begin: "400ms",
    dur: "1s",
    values: "1;.2;1",
    calcMode: "linear",
    repeatCount: "indefinite"
  })), /*#__PURE__*/_react.default.createElement("circle", {
    cx: "12.5",
    cy: "92.5",
    r: "12.5"
  }, /*#__PURE__*/_react.default.createElement("animate", {
    attributeName: "fill-opacity",
    begin: "700ms",
    dur: "1s",
    values: "1;.2;1",
    calcMode: "linear",
    repeatCount: "indefinite"
  })), /*#__PURE__*/_react.default.createElement("circle", {
    cx: "52.5",
    cy: "92.5",
    r: "12.5"
  }, /*#__PURE__*/_react.default.createElement("animate", {
    attributeName: "fill-opacity",
    begin: "500ms",
    dur: "1s",
    values: "1;.2;1",
    calcMode: "linear",
    repeatCount: "indefinite"
  })), /*#__PURE__*/_react.default.createElement("circle", {
    cx: "92.5",
    cy: "92.5",
    r: "12.5"
  }, /*#__PURE__*/_react.default.createElement("animate", {
    attributeName: "fill-opacity",
    begin: "200ms",
    dur: "1s",
    values: "1;.2;1",
    calcMode: "linear",
    repeatCount: "indefinite"
  })))), /*#__PURE__*/_react.default.createElement("div", {
    style: {
      marginTop: '2rem'
    }
  }, "Initialising seating plan...")));
};
var _default = SeatingPlan;
exports.default = _default;